<template>
  <YdDialog :visible="visible" append-to-body @close="close" width="60%" title="活动奖品">
    <el-button
      type="primary"
      icon="el-icon-plus"
      size="mini"
      :disabled="recordList.length === 8"
      @click="handleAdd('prize')"
      >新增奖品</el-button
    >
    <el-button
      type="primary"
      icon="el-icon-plus"
      size="mini"
      :disabled="recordList.length === 8"
      @click="handleAdd('none')"
      >新增谢谢参与</el-button
    >
    <yd-table :loading="loading" :data="recordList" border size="mini">
      <el-table-column label="序号" type="index" width="50" align="center" key="index">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="奖品名称" prop="prizeName" align="center" />
      <el-table-column label="奖品价值" prop="price" align="center" />
      <el-table-column label="数量（已中奖量/奖品库存量）" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.type === 4">-</div>
          <div v-else>{{ scope.row.winNumbers || 0 }}/{{ scope.row.stockNumbers || 0 }}</div>
        </template>
      </el-table-column>
      <el-table-column label="中奖概率" prop="winnerRate" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.winnerRate.toFixed(2) + '%' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="sort" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #d9001b" @click="handleDel(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </yd-table>
    <div slot="footer">
      <!-- <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="exportExcel">保 存</el-button> -->
    </div>
    <prize-edit
      :visible="showEdit"
      ref="prizeEdit"
      :prizeType="prizeType"
      :activityId="activityId"
      :activeStatus="activeStatus"
      @close="editClose"
      @init="editSubmit"
    />
  </YdDialog>
</template>

<script>
  import prizeEdit from './prize-edit.vue'
  import { activePrizeList, prizeDel } from '@/api/marketing/prize-draw'
  export default {
    name: 'prizeStatistics',
    data() {
      return {
        recordList: [],
        showEdit: false,
        prizeType: ''
      }
    },
    components: {
      prizeEdit
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      activityId: {
        type: String,
        default: ''
      },
      activeStatus: {
        type: String,
        default: ''
      }
    },
    mounted() {},
    methods: {
      close() {
        this.recordList = []
        this.$emit('close')
      },
      initPage(id) {
        activePrizeList(id).then((res) => {
          if (res.code) return
          res.data.forEach((item) => {
            item.price =
              item.type === 4 ? '-' : (item.price / 100).toFixed(2) + (item.type === 2 ? '元' : '')
          })
          this.recordList = res.data
        })
      },
      handleAdd(type) {
        this.prizeType = type
        this.showEdit = true
        this.$refs.prizeEdit.init({ id: '' })
      },
      editClose() {
        this.showEdit = false
      },
      handleDel(id) {
        this.$confirm('是否删除该奖品?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.$loading()
            const params = {
              activityId: this.activityId,
              rafflePrizeId: id
            }
            prizeDel(params)
              .then((res) => {
                if (res.code) return
                this.$message.success('删除成功')
                this.initPage(this.activityId)
              })
              .finally(() => {
                this.$loading().close()
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
            this.$loading().close()
          })
      },
      handleEdit(row) {
        this.showEdit = true
        this.prizeType = 'prize'
        this.$refs.prizeEdit.init(JSON.parse(JSON.stringify(row)))
      },
      editSubmit() {
        this.initPage(this.activityId)
      }
    }
  }
</script>
<style scoped lang="scss">
  .title-box {
    margin: 0 0 20px 10px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }
</style>
